import { Badge } from 'react-bootstrap';

interface ISectionTitleProps {
  label: string;
  className?: string;
  size?: 'lg' | 'sm';
  dataTestId?: string;
  pill?: 'APP' | 'SMS';
}

const SectionTitle = ({ label, className, size = 'sm', dataTestId, pill }: ISectionTitleProps) => {
  return (
    <h6
      data-test={dataTestId}
      className={`text-uppercase ${size === 'sm' && 'text-sm'} ${className}`}
    >
      {label}
      {pill && (
        <Badge
          data-test={`${dataTestId}-pill`}
          pill
          bg={pill === 'APP' ? 'primary' : 'blue-light'}
          className="ms-2"
        >
          {pill}
        </Badge>
      )}
    </h6>
  );
};

export default SectionTitle;
